import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import TagActions from 'actions/TagActions';
import {Record} from 'immutable';

@immutableStore
class TagStore {
  constructor() {
    this.state = Record({
      // a list of tags from the most recent request
      // unread count will depend on which filters were last applied
      tags: undefined,
      isLoading: true,
      wasError: false,
    })();
    this.bindActions(TagActions);
  }

  clearTags() {
    this.setState({tags: null});
  }

  fetchTags() {
    this.setState({isLoading: true, wasError: false});
  }

  fetchTagsSuccess([filters, tags]) {
    this.setState({isLoading: false, tags});
  }

  fetchTagsError() {
    this.setState({isLoading: false, wasError: true});
  }
}

export default alt.createStore(TagStore);
